import React from "react";

const Deal = ({ headline, info, price, min }) => {
  const whatsappNumber = "+972549432343"; // WhatsApp number
  const message = `היי, התעניינתי ב ${headline}`;

  const handleWhatsAppClick = () => {
    const whatsappLink = `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodeURIComponent(
      message
    )}`;
    window.open(whatsappLink, "_blank");
  };

  const infoLines = info.split("\n"); // Split the info text into lines

  return (
    <div className="max-w-[90%] lg:max-w-[60%]  mx-auto my-8 px-2 shadow-2xl shadow-orange-50 bg-transparent border-2 text-white rounded-3xl  z-10">
      <div className="flex flex-col p-6 space-y-8">
        <div className="flex justify-between items-start">
          <h3
            dir="rtl"
            className="gold-text bg-black text-sm font-bold rounded-lg"
          >
            {price} ש"ח למנה
          </h3>
          <h3
            dir="rtl"
            className="gold-text bg-black text-sm font-bold rounded-lg"
          >
            {" "}
            {min}
          </h3>
        </div>
        <h2 className="text-2xl font-bold text-center">{headline}</h2>

        <ul dir="rtl" className="text-lg text-center">
          {infoLines.map((line, index) => (
            <li key={index}>{line}</li>
          ))}
        </ul>

        <button
          onClick={handleWhatsAppClick}
          className="mt-4 mx-auto rounded-full flex items-center border-4 py-2 bg-gradient-to-l from-black to-[#333] text-textSave px-7  hover:opacity-95 hover:scale-[108%] duration-300 shadow-lg"
        >
          <span className="gold-text text-base mb-1 font-black" dir="rtl">
            אני רוצה להזמין!
          </span>
        </button>
        <p className="text-xs text-right">משלוח לאירוע (חם) 150 ש"ח</p>
      </div>
    </div>
  );
};

export default Deal;
